/**
 * LiveKit client config (browser connects directly to the LiveKit server).
 */
export const LIVEKIT_WS_URL =
  process.env.REACT_APP_LIVEKIT_WS_URL || 'wss://chattitude-tbb4jl8j.livekit.cloud';


export function buildVoiceRoomName(tenantId, agentId, sessionId) {
  const safeAgent = String(agentId).replace(/[^a-zA-Z0-9._-]/g, '_');
  const safeSession = String(sessionId).replace(/[^a-zA-Z0-9._-]/g, '_');
  return `voice-${tenantId}-${safeAgent}-${safeSession}`;
}

export function buildUserIdentity(clientId) {
  return `user-${clientId || 'widget'}`;
}
